import React from "react";
import { useField, useFormikContext } from "formik";
import PropTypes from "prop-types";

import Error from "src/shared/components/Error";
import listingProps from "src/shared/utilities/graphql/listingProps";
import useAbTests from "src/shared/utilities/useAbTests";

import analytics from "../../utilities/analytics";
import { useDrawerContext } from "../../utilities/drawerHelpers";
import useActiveExperts from "../../utilities/hooks/useActiveExperts";
import useFeatureState from "../../utilities/hooks/useFeatureState";
import ContactFormFooter from "../ContactFormFooter";
import ExpertContainer from "../ExpertContainer";
import BuyerSellerSwitch from "./BuyerSellerSwitch";
import * as S from "./styled";

const EMAIL_TYPE = "email";
const TEXT_TYPE = "text";
const TEXTAREA_TYPE = "textarea";

const ContactForm = ({ listing }) => {
  const {
    fossa_contact_box_email_input_update: abTestVariant,
    loading: abTestsLoading
  } = useAbTests("fossa_contact_box_email_input_update");

  const hasDrawerForm = useDrawerContext();
  const { expertsApiUuid } = useFeatureState();
  const { expert } = useActiveExperts();
  const { isSubmitting } = useFormikContext();
  const [, { error }] = useField("form_submission");

  const onBuySellSwitchChange = event => {
    const switchChoice = event.target.value;

    analytics({
      action: "building_expert_event",
      event_label: `${
        switchChoice === "buy" ? "select_buy" : "select_sell"
      }|expert_contact_id=${expert.contact.id}|pro=${
        expert.contact.is_pro
      }|uuid=${expertsApiUuid}`,
      isHdp: false
    });
  };

  if (abTestsLoading) return null;

  const showNewEmailInput = abTestVariant === "new";

  return (
    <>
      <S.Wrapper data-testid="contact-box-form">
        <ExpertContainer />

        {hasDrawerForm && !listing && (
          <BuyerSellerSwitch onChangeValue={onBuySellSwitchChange} />
        )}

        <S.Input labelText="Name" name="name" required type={TEXT_TYPE} />
        <S.Input
          labelText="Phone Number"
          name="phone"
          required
          type={TEXT_TYPE}
        />
        {showNewEmailInput ? (
          <S.Input label="Email" name="email" required type={EMAIL_TYPE} />
        ) : (
          <S.Input labelText="Email" name="email" required type={TEXT_TYPE} />
        )}
        <S.Input
          labelText="Message"
          name="body"
          required
          type={TEXTAREA_TYPE}
        />

        {error && <Error>{error}</Error>}

        <S.Button disabled={isSubmitting} theme="primary" type="submit">
          {isSubmitting ? "Sending..." : "Send Message"}
        </S.Button>
      </S.Wrapper>

      <ContactFormFooter listing={listing} />
    </>
  );
};

ContactForm.propTypes = {
  listing: PropTypes.shape(listingProps)
};

ContactForm.defaultProps = {
  listing: null
};

export default ContactForm;
